import BaseApi from './BaseApi'

class AdviserProfilesSearchApi extends BaseApi {

  get searchResultsUrl () {
    return 'search'
  }

  get totalMatchesUrl () {
    return 'search/totalMatches'
  }

  getSearchFindByNameUrl (name) {
    return 'findIfa/' + name
  }

  getAdminSearchFindByNameUrl (name) {
    return 'adminFindIfa/' + name
  }

  async searchPublished (searchCriteria) {
    searchCriteria.userAddress = searchCriteria.userAddress || ''

    const response = await this.postJson(this.searchResultsUrl, searchCriteria)
    const data = await response.json()
    return data
  }

  searchPublishedProfilesByName (ifaName) {
    return this.getJson(this.getSearchFindByNameUrl(ifaName))
  }

  adminSearchPublishedProfilesByName (ifaName) {
    return this.getJson(this.getAdminSearchFindByNameUrl(ifaName))
  }

  getTotalMatches (searchCriteria) {
    return this.postJson(this.totalMatchesUrl, searchCriteria)
  }

}

export default AdviserProfilesSearchApi
